import type { ClientNotification as ServerNotification } from '../../../shared/domain/notifications/types.no-deps'
import type { Replace } from '../../../shared/lib/typeHelpers.no-deps'

/**
 * This is the type for the in-app notifications displayed on the notifications page
 * We need to index by createdAt in indexed db, which means we have to change it to unixTime
 */
export type Noti_IDBNotification = Replace<ServerNotification, { createdAt: number }>

export function Noti_toIDBNotification(serverNotification: ServerNotification): Noti_IDBNotification {
    return {
        ...serverNotification,
        createdAt: serverNotification.createdAt.getTime(),
    }
}
